import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IUserProfile } from '../components/userprofile/models/user-profile.model';

@Injectable({
  providedIn: 'root'
})
export class UserUpdateService {

  constructor() { }
  private userNameSubject = new BehaviorSubject<IUserProfile | null>(null);
  userName$ = this.userNameSubject.asObservable();

  updateUserName(name: IUserProfile) {
    this.userNameSubject.next(name);
  }
}
